import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { TableContainer } from "@mui/material";
import { thStyle, tdStyle, inputStyle } from "../addstock/tableStyles";
import { Button, Typography, TextField } from "@mui/material";
import style from "./Customer.module.css";

export default function ReportTable({
    columns,
    allCategories,
    handleEditData,
    searchInput,
    setSearchInput,
  }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
    const [currentPage, setCurrentPage] = useState(1);
  
    const handleSearchSubmit = () => {
      console.log("Searching for:", searchTerm);
    };
  
    const filteredData = searchInput
      ? allCategories?.filter((item) =>
          Object.values(item).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(searchInput.toLowerCase())
          )
        )
      : allCategories;
  
    const displayedData = filteredData?.slice(
      (currentPage - 1) * rowsPerPages,
      currentPage * rowsPerPages
    );
  
    const preprocessedData = displayedData?.map((product, idx) => ({
      ...product,
      Id: product.Id !== undefined ? product.Id : `temp-id-${idx}`,
      serialNumber: (currentPage - 1) * rowsPerPages + idx + 1, // Add serial number
    }));
  
    const getGrossWt = (product) => {
      // Access the first item in purchaseItem array and retrieve GrossWt
      return product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].GrossWt : '';
    };
    const getNetWt = (product) => {
      // Access the first item in purchaseItem array and retrieve GrossWt
      return product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].NetWt : '';
    };

    const getFPlusWPer = (product) => {
      // Access the first item in purchaseItem array and retrieve GrossWt
    const FinePercentage =  product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].FinePercent : '';

    const WastagePercentage =  product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].WastagePercent : '';
  
    const FPlusWPer = parseFloat(FinePercentage) + parseFloat(WastagePercentage);

    return FPlusWPer ? FPlusWPer.toFixed(1) : '';
  
  };

  const getFPlusWWt = (product) => {
    // Access the first item in purchaseItem array and retrieve GrossWt
  const FineWt =  product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].FineWt : '';

  const WastageWt =  product.purchaseItem && product.purchaseItem[0] ? product.purchaseItem[0].WastageWt : '';

  const FPlusWWt = parseFloat(FineWt) + parseFloat(WastageWt);

  return FPlusWWt ? FPlusWWt.toFixed(3) : '';

};
  
  
    const totalPages = Math.ceil(filteredData.length / rowsPerPages);
  
    const handlePageClick = (page) => {
      if (page <= totalPages) setCurrentPage(page); // Only set page if it's within range
    };
  
    const handleRowsPerPageChange = (event) => {
      setRowsPerPages(parseInt(event.target.value, 10));
      setCurrentPage(1); // Reset to first page whenever rows per page changes
    };
  
    return (
      <>
        <div className={style["table-container"]}>
          <table className={style["custom-table"]}>
            <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.key}
                    style={{
                      padding: "8px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                      backgroundColor: "#627383",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "600",
                      minWidth: "fit-content",
                    }}
                  >
                    {column.label}
                  </th>
                ))}
                <th
                  style={{
                    fontSize: "12px",
                    position: "sticky",
                    right: 0,
                    background: "#627282",
                    zIndex: 1,
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {preprocessedData?.map((product, idx) => (
                <tr
                  key={product.Id}
                  className={`${style.tableRow} ${
                    idx % 2 === 0 ? style.evenRow : style.oddRow
                  }`}
                >
                  {/* {columns.map((column) => (
                    <td
                      style={{ fontSize: "12px" }}
                      key={column.key}
                      className={style.tableCell}
                    >
                      {column.type === "read" &&
                        (column.key === "GrossWt"
                          ? getGrossWt(product) 
                          : product[column.key])}

                       {column.type === "read" &&
                        (column.key === "NetWt"
                          ? getNetWt(product) 
                          : product[column.key])}

                       {column.type === "read" &&
                        (column.key === "FPlusWPer"
                          ? getFPlusWPer(product) 
                          : product[column.key])}

                       {column.type === "read" &&
                        (column.key === "FPlusWWt"
                          ? getFPlusWWt(product) 
                          : product[column.key])}
                    </td>
                  ))} */}

{columns?.map((column) => (
  <td
    style={{ fontSize: "12px" }}
    key={column.key}
    className={style.tableCell}
  >
    {column.type === "read" &&
      (column.key === "serialNumber"
        ? product.serialNumber // Render serial number
        : column.key === "GrossWt"
        ? getGrossWt(product)
        : column.key === "NetWt"
        ? getNetWt(product)
        : column.key === "FPlusWPer"
        ? getFPlusWPer(product)
        : column.key === "FPlusWWt"
        ? getFPlusWWt(product)
        : product[column.key])}
  </td>
))}

                  <td
                    style={{
                      fontSize: "12px",
                      position: "sticky",
                      right: -9,
                      zIndex: 1,
                    }}
                  >
                    <div className={style["action-container"]}>
                      <Icon
                        onClick={() => handleEditData(product)}
                        style={{ color: "#627282", cursor: "pointer" }}
                        icon="material-symbols-light:edit-outline"
                        width="20"
                        height="20"
                      />
                      <Icon
                        style={{ color: "#627282", cursor: "pointer" }}
                        icon="weui:delete-filled"
                        width="20"
                        height="20"
                      />
                      <Icon
                        style={{ color: "#627282", cursor: "pointer" }}
                        icon="ic:outline-print"
                        width="20"
                        height="20"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
  
        <div className={style["page-controls"]}>
          <div className={style["pagination"]}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <div
                key={page}
                className={
                  currentPage === page
                    ? style["pagination-pages-active"]
                    : style["pagination-pages"]
                }
                onClick={() => handlePageClick(page)}
              >
                {page}
              </div>
            ))}
          </div>
  
          <div className={style["rows-per-page"]}>
            <label htmlFor="rows-per-page">Rows per page</label>
            <select
              id="rows-per-page"
              value={rowsPerPages}
              onChange={handleRowsPerPageChange}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>
      </>
    );
  }
  
